import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../Button/Button';
import BUTTON_CONFIG from '../../constants/button.constants';
import { UPLOAD_TO_KPHC_BUTTON_ID } from '../../constants/dom.constants';
import { UPLOAD_STATUS_TEXT_MAP } from '../../constants/media.constants';
import { STORE_NAMES } from '../../constants/store.constants';
import { uploadImages } from '../../service/media.service';
import MediaActions from '../../store/actions/MediaAction';

const UploadMediaButton = () => {
  const dispatch = useDispatch();
  const { selectedImages, imageIdBeingEdited } = useSelector(state => state?.[STORE_NAMES.MEDIA]);
  const { meetingID: zoomMeetingId, meetingUUID: zoomMeetingUuid } = useSelector(state => state?.[STORE_NAMES.ZOOM_CLIENT]);
  const { provider: { id, idType, region } = {} } = useSelector(state => state?.[STORE_NAMES.APP]);

  const prepareImageUploadStatusMap = responseBody => {
    const uploadStatusMap = {};
    responseBody.images.forEach(image => {
      const { fileId, uploadStatus } = image;
      if (fileId && uploadStatus) {
        uploadStatusMap[fileId] = uploadStatus;
      }
    });
    return uploadStatusMap;
  };

  const prepareImagesUploadRequestBody = () => {
    const imagesUploadRequestBody = {
      region,
      zoomMeetingId,
      zoomMeetingUuid,
      provider: {
        id,
        idType
      },
      images: selectedImages
    };
    return imagesUploadRequestBody;
  };

  const cleanupState = () => {
    // clear selected images everytime user clicks on upload button to reset ui
    dispatch(MediaActions.clearSelectedImages());
    // reset error status before starting the upload to reset ui
    dispatch(MediaActions.setDisplayUploadServiceErrorNotification(false));
    // hide partial error notification if it was displayed previously
    dispatch(MediaActions.setDisplayPartialErrorNotification(false));
  };

  const uploadSelectedImages = async () => {
    // clean other dependent states before starting the upload
    cleanupState();

    // disable image list interaction to prevent further actions while upload is in progress
    dispatch(MediaActions.disableImageListInteraction(true));

    try {
      const imagesUploadRequestBody = prepareImagesUploadRequestBody();
      const responseBody = await uploadImages(imagesUploadRequestBody);
      if (Array.isArray(responseBody?.images) && responseBody.images.length) {
        const uploadStatusMap = prepareImageUploadStatusMap(responseBody);
        dispatch(MediaActions.updateImagesUploadStatus(uploadStatusMap));

        if (responseBody.images.some(image => image.uploadStatus === UPLOAD_STATUS_TEXT_MAP.FAILED)) {
          dispatch(MediaActions.setDisplayPartialErrorNotification(true));
        }
      }
    } catch {
      dispatch(MediaActions.setDisplayUploadServiceErrorNotification(true));
    } finally {
      dispatch(MediaActions.disableImageListInteraction(false));
    }
  };

  const handleUploadClick = () => {
    uploadSelectedImages();
  };

  return (
    <div className="vve-invite-btn-container vve-uploadmedia-btn-container">
      <Button
        onClick={handleUploadClick}
        class="btn btn-primary btn-lg"
        id={UPLOAD_TO_KPHC_BUTTON_ID}
        disabled={selectedImages.length === 0 || imageIdBeingEdited !== null}
      >
        {BUTTON_CONFIG.UPLOAD_TO_KPHC_BUTTON.title}
      </Button>
    </div>
  );
};

export default UploadMediaButton;
